import React from "react";
import { motion } from "framer-motion";

export const SectionHeading = ({
    eyebrow,
    title,
    subtitle,
    align = "left",
    className = "",
    serifTitle = true,
    accent = "gold",
}) => {
    return (
        <div
            className={`flex flex-col gap-4 ${
                align === "center" ? "items-center text-center" : "items-start"
            } ${className}`}
        >
            {eyebrow && (
                <motion.span
                    initial={{ opacity: 0, y: 8 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-10% 0px" }}
                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    className="inline-flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.22em] text-[hsl(var(--text-muted))]"
                >
                    <span
                        className={`inline-block h-1.5 w-1.5 rounded-full ${
                            accent === "gold"
                                ? "bg-[hsl(var(--gold))] shadow-[0_0_10px_rgba(187,118,33,0.55)]"
                                : "bg-[hsl(var(--blue))] shadow-[0_0_10px_rgba(37,99,235,0.55)]"
                        }`}
                    />
                    {eyebrow}
                </motion.span>
            )}
            {title && (
                <motion.h2
                    initial={{ opacity: 0, y: 12, filter: "blur(6px)" }}
                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                    viewport={{ once: true, margin: "-10% 0px" }}
                    transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
                    className={`max-w-3xl text-balance ${
                        serifTitle ? "font-display" : "font-sans"
                    } text-[34px] sm:text-[44px] lg:text-[58px] leading-[1.02] tracking-[-0.02em] text-[hsl(var(--text))]`}
                >
                    {title}
                </motion.h2>
            )}
            {subtitle && (
                <motion.p
                    initial={{ opacity: 0, y: 8 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-10% 0px" }}
                    transition={{ duration: 0.5, delay: 0.05, ease: [0.16, 1, 0.3, 1] }}
                    className="max-w-2xl text-[15.5px] sm:text-[17px] leading-[1.65] text-[hsl(var(--text-muted))] text-pretty"
                >
                    {subtitle}
                </motion.p>
            )}
        </div>
    );
};

export default SectionHeading;
